import WorkflowDisenoPage from '../configuracion/workflow/definicion-workflow/workflow-diseno-page';

export default function WorkflowAppDisenoPage() {
  return <WorkflowDisenoPage variant="app" />;
}
